import React, { useEffect, useRef } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

export default function SponserSlider() {
  const carouselRef = useRef();

  useEffect(() => {

    if (typeof window === "undefined" || !window.$) return;
    window.$ = window.jQuery = $;

      const $carousel = window.$(carouselRef.current);

      if (typeof $.fn.owlCarousel === "function") {
        $carousel.owlCarousel({
          autoplay: true,
          loop: true,
          margin: 15,
          dots: false,
          slideTransition: "linear",
          autoplayTimeout: 4500,
          autoplayHoverPause: true,
          autoplaySpeed: 4500,
          responsive: {
            0: { items: 2 },
            500: { items: 3 },
            600: { items: 4 },
            800: { items: 5 },
            992: { items: 6 },
            1200: { items: 7 },
          },
        });
      } else {
        console.error("Owl Carousel still not attached to jQuery!");
      }

    return () => {
      try {
        $(carouselRef.current).trigger("destroy.owl.carousel");
      } catch (err) {
        console.warn("Owl destroy failed:", err);
      }
    };
  }, []);

  const sponsors = [
    "/images/client-1.webp",
    "/images/client-2.webp",
    "/images/client-3.webp",
    "/images/client-4.webp",
    "/images/client-5.png",
    "/images/client-6.png",
    "/images/client-7.png",
    "/images/client-8.png",
    "/images/client-9.png",
    "/images/client-10.png",
    "/images/client-11.png",
    "/images/client-12.png",
    "/images/client-13.webp",
    "/images/client-14.webp",
  ];

  return (
        <div ref={carouselRef} className="owl-carousel owl-theme">
          {sponsors.map((src, i) => (
            <div key={i} className="item flex justify-center items-center px-3 sponser-box">
              <img
                src={src}
                alt={`Client ${i + 1}`}
                className="h-14 object-contain opacity-70 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-300 sponser-img"
              />
            </div>
          ))}
        </div>
  );
}
